import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { Tenant } from '../../entities/tenant/tenant';
import { LoadingService } from '../../services/loading.service';
import { RolesService } from '../../services/roles/roles.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { ToastService } from '../../services/toast/toast.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { TenantDialogComponent } from '../tenant-dialog/tenant-dialog.component';
import { TenantDataSource } from './tenantDataSource';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.scss']
})
export class TenantListComponent implements OnDestroy, OnInit {

  dialogRef: DynamicDialogRef | undefined;

  public sortProperty: string;
  public defaultSortProperty: string = 'id';
  public sortDirection: string;
  public defaultSortDirection: string = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  public sortModel: any;
  public sortOptions = [
    { label: 'Keine Sortierung', fieldName: 'id', direction: "asc"},
    { label: 'Name aufsteigend', fieldName: 'name', direction: "asc"},
    { label: 'Name absteigend', fieldName: 'name', direction: "desc" }
  ];

  public dataSource: TenantDataSource;
  public loading = false;
  public name: string;

  constructor(
    private router: Router,
    private apollo: Apollo,
    public tenantService:TenantsService,
    public rolesService: RolesService,
    private cdRef: ChangeDetectorRef,
    public dialogService: EditDialogService,
    public loadingService: LoadingService,
    public toastService: ToastService,
    @Inject('env') private environment : any

  ) {
  }

  ngOnInit(): void {
    this.dataSource = new TenantDataSource(this.apollo, this.environment);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadTenants({
      pageNumber: 0,
      pageSize: 15,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      name: this.name
    });
  }

  refetchTenants(force = false): void {
    this.dataSource.refetchQuery({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      name: this.name
    }, force);
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = NXDataSourcePrime.translateSortOrderToSortDirection(event.sortOrder);
    }

    //filtering
    this.name = event.globalFilter as string;

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;

    this.refetchTenants();
  }

  sort(event: any) {
    if(event?.value?.direction && event?.value?.fieldName){
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }

  createTenant(): void {
    this.dialogRef = this.dialogService.open(TenantDialogComponent, {
      header: 'Tenant erstellen'
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.refetchTenants(true);
        this.loadingService.setLoading(false);
        this.toastService.addToastWithAction('Tenant erfolgreich erstellt.', 'Anzeigen', () => {
          this.router.navigate(['./settings/tenants/tenant/' + result]);
        });
      }
    });
  }

  openTenant(tenant: Tenant) {
    this.router.navigate(['./settings/tenants/tenant/' + tenant.id]);
  }

  copyToClipboard(stringToCopy: string): void {
    navigator.clipboard.writeText(stringToCopy).then(() => {
      this.toastService.addToastWithMessage('Tenant-ID kopiert.');
    }).catch(() => {
      // error
    });
  }


}
